/**
 * Route for `kpi-visibility-per-report-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { KpiVisibilityPerReportPerRolePage } from "../features/kpi-visibility-per-report-per-role/KpiVisibilityPerReportPerRolePage";

export const kpiVisibilityPerReportPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/kpi-visibility-per-report-per-role",
	component: KpiVisibilityPerReportPerRolePage,
});

export default kpiVisibilityPerReportPerRoleRoute;
